import {useTranslation} from "react-i18next";

const IntakePlan = ({selectedDrug, showHeader = true}) => {
  const { t } = useTranslation();

  return (
    <>
      {showHeader && (
        <header className="w3-container w3-padding-small w3-center">
          <h2 className="w3-left">
            {t(/** @type {any} */ "your_intake_plan_for")}{" "}{selectedDrug?.productName}
          </h2>
        </header>
      )}
      <div className="w3-container">
        <div className="w3-row">
          <label>{t(/** @type {any} */ "intake")}: {" "}{t(selectedDrug?.intakeType)?.toLowerCase()}</label>
        </div>
        <div className="w3-row">
          <label>{t(/** @type {any} */ "frequency")}: {t(/** @type {any} */ "every")?.toLowerCase()} {selectedDrug?.frequency} {t(selectedDrug?.frequencyUnit)}</label>
        </div>
        <div className="w3-row w3-margin-top">
          <div>
            <label>{t(/** @type {any} */ "drug_intakes")}:</label>
            {selectedDrug?.intakes?.map((intake, i) => {
              return (
                <div className="w3-row w3-margin-left" key={`intake${i}`}>
                  <label>
                    {intake?.dosage} {t(intake?.dosageUnit)}{" "}
                    {t(/** @type {any} */ "at")} {intake?.intakeTime}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default IntakePlan;